import { urlBaseLeadCollector } from "../config";
import axiosInstance from "../../services/config/axiosinstance";
import GuestReportModel from "../../models/GuestReportModel";

export default async function getGuestsWithClassificationBySchedule(
  scheduleId = '',
  limit = 10,
  offset = 0
) {
  try {
    const _config = {
      method: 'GET',
      url: `${urlBaseLeadCollector}/guest/getGuestsWithClassification?scheduleId=${scheduleId}&limit=${limit}&offset=${offset}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    let _return = {
      data: [GuestReportModel()],
      count: 0,
    }
    _return.data = [];

    for (let i = 0; i < _ret.data.data.data.length; i++) {
      _return.data.push(GuestReportModel({ ..._ret.data.data.data[i] }));
    }
    _return.count = _ret.data.data.count;

    return _return;

  } catch (error) {
    console.log('Error getGuestsWithClassificationBySchedule', error);
    throw error;
  }
}
